export enum SelectFormat {
    Dropdown = 0,
    CheckboxRadio = 1
}
